import classNames from 'classnames';
import Typography from 'components/generics/texts/Typography';
import React, { HTMLAttributes } from 'react';
import { parseMoney } from 'utils/money_utils';
import classes from 'components/generics/forms/DebtForm/components/DebtFormSubtitle/index.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  price: number;
}

const DebtFormSubtitle = ({ price, className }: Props) => {
  return (
    <Typography className={classNames(classes.container, className)}>
      {parseMoney(price)} / Share
    </Typography>
  );
};

export default DebtFormSubtitle;
